import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['voyageReportsStore', 'userStore', 'dataSyncStore']),
    ...mapGetters({
      getSyncedAndUnSyncedVoyageReports: 'voyageReportsStore/getSyncedAndUnSyncedVoyageReports',
      getAllUnSyncedVesselActivities: 'dataSyncStore/getAllUnSyncedVesselActivities',
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
      getActiveSite: 'userStore/getActiveSite',
      getAllUnsyncedPassengers: 'dataSyncStore/getAllUnsyncedPassengers',
    }),
    anyUnsyncedVoyageReports() {
      return this.getSyncedAndUnSyncedVoyageReports.some((x) => (x && x.idc));
    },
    anyUnsynedVesselActivities() {
      return this.getAllUnSyncedVesselActivities.length > 0;
    },
    anyUnsyncedPassengers() {
      return this.getAllUnsyncedPassengers.length > 0;
    },
    anyUnsyncedItems() {
      return this.anyUnsyncedVoyageReports
        || this.anyUnsynedVesselActivities
        || this.anyUnsyncedPassengers;
    },
  },
  methods: {
    isVoyageUnsynced(voyage) {
      const isAnyUnsyncedActivitiesForVoyage = this.isAnyUnsyncedActivitiesForVoyage(voyage);
      const isAnyUnsyncedPassengersForVoyage = this.isAnyUnsyncedPassengersForVoyage(voyage);
      const voyageHasIdc = !!voyage.idc;
      return voyageHasIdc || isAnyUnsyncedActivitiesForVoyage || isAnyUnsyncedPassengersForVoyage;
    },
    isAnyUnsyncedActivitiesForVoyage(voyage) {
      return this.getAllUnSyncedVesselActivities
        .some((x) => (x.voyageReportId === voyage.id
          || (x.voyageReport && x.voyageReport.id === voyage.id)));
    },
    isAnyUnsyncedPassengersForVoyage(voyage) {
      const passengersForVoyage = this.getAllUnsyncedPassengers
        .filter((x) => (voyage.id && x.voyageReportId && voyage.id === x.voyageReportId)
          || (voyage.idc && x.voyageReportIdc && voyage.idc === x.voyageReportIdc));

      return passengersForVoyage.length > 0;
    },
    goToVoyageDetails(item) {
      // Server Id or Client Id
      const { id } = item;
      const idc = item.idc ? item.idc.toString() : null;
      this.$router.push({ name: 'voyagedetails', params: { id, idc } });
    },
  },
};
